import template from "./physical_cash_count.html";
import controller from "./physical_cash_count.controller";
import "./physical_cash_count.scss";

let branchManagementPhysicalCashCountComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementPhysicalCashCountComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/physical_cash_count.component.js